
export const coreModules = [
  {
    id: 'property-tax',
    name: 'Property Tax',
    description: 'Comprehensive property tax assessment, collection, and management system',
    icon: 'ri-home-4-line',
    category: 'Citizen Services',
    apiDocs: '/docs/property-tax-api',
    userDocs: '/docs/property-tax-user'
  },
  {
    id: 'trade-license',
    name: 'Trade License',
    description: 'Digital trade license application, approval, and renewal processes',
    icon: 'ri-store-2-line',
    category: 'Citizen Services',
    apiDocs: '/docs/trade-license-api',
    userDocs: '/docs/trade-license-user'
  },
  {
    id: 'water-sewerage',
    name: 'Water & Sewerage',
    description: 'Water connection management, billing, and sewerage service administration',
    icon: 'ri-drop-line',
    category: 'Citizen Services',
    apiDocs: '/docs/water-sewerage-api',
    userDocs: '/docs/water-sewerage-user'
  },
  {
    id: 'solid-waste',
    name: 'Solid Waste Management',
    description: 'Waste collection scheduling, route optimization, and disposal tracking',
    icon: 'ri-delete-bin-line',
    category: 'Citizen Services',
    apiDocs: '/docs/solid-waste-api',
    userDocs: '/docs/solid-waste-user'
  },
  {
    id: 'fire-noc',
    name: 'Fire NOC',
    description: 'Fire safety clearance applications and compliance management',
    icon: 'ri-fire-line',
    category: 'Citizen Services',
    apiDocs: '/docs/fire-noc-api',
    userDocs: '/docs/fire-noc-user'
  },
  {
    id: 'building-plan',
    name: 'Building Plan Approval (OBPS)',
    description: 'Online building plan submission, review, and approval workflow',
    icon: 'ri-building-line',
    category: 'Citizen Services',
    apiDocs: '/docs/building-plan-api',
    userDocs: '/docs/building-plan-user'
  },
  {
    id: 'grievance-redressal',
    name: 'Public Grievance Redressal',
    description: 'Citizen complaint registration, tracking, and resolution system',
    icon: 'ri-customer-service-line',
    category: 'Citizen Services',
    apiDocs: '/docs/grievance-api',
    userDocs: '/docs/grievance-user'
  },
  {
    id: 'grievance-feedback',
    name: 'Public Grievance Feedback',
    description: 'Feedback collection and satisfaction measurement for resolved grievances',
    icon: 'ri-feedback-line',
    category: 'Citizen Services',
    apiDocs: '/docs/feedback-api',
    userDocs: '/docs/feedback-user'
  },
  {
    id: 'birth-death',
    name: 'Birth & Death Registration',
    description: 'Digital registration and certificate issuance for vital events',
    icon: 'ri-file-list-3-line',
    category: 'Citizen Services',
    apiDocs: '/docs/birth-death-api',
    userDocs: '/docs/birth-death-user'
  },
  {
    id: 'marriage-registration',
    name: 'Marriage Registration',
    description: 'Online marriage registration and certificate generation system',
    icon: 'ri-heart-line',
    category: 'Citizen Services',
    apiDocs: '/docs/marriage-api',
    userDocs: '/docs/marriage-user'
  },
  {
    id: 'public-health',
    name: 'Public Health',
    description: 'Health service delivery, vaccination tracking, and health monitoring',
    icon: 'ri-health-book-line',
    category: 'Citizen Services',
    apiDocs: '/docs/health-api',
    userDocs: '/docs/health-user'
  },
  {
    id: 'streetlight',
    name: 'Streetlight Maintenance',
    description: 'Streetlight monitoring, maintenance scheduling, and energy management',
    icon: 'ri-lightbulb-line',
    category: 'Administrative',
    apiDocs: '/docs/streetlight-api',
    userDocs: '/docs/streetlight-user'
  }
];

export const administrativeModules = [
  {
    id: 'finance',
    name: 'Finance',
    description: 'Comprehensive financial management, budgeting, and accounting system',
    icon: 'ri-money-dollar-circle-line',
    category: 'Administrative',
    apiDocs: '/docs/finance-api',
    userDocs: '/docs/finance-user'
  },
  {
    id: 'inventory',
    name: 'Inventory',
    description: 'Asset and inventory management with procurement and stock control',
    icon: 'ri-archive-line',
    category: 'Administrative',
    apiDocs: '/docs/inventory-api',
    userDocs: '/docs/inventory-user'
  },
  {
    id: 'hrms',
    name: 'HRMS',
    description: 'Human resource management, payroll, and employee lifecycle management',
    icon: 'ri-team-line',
    category: 'Administrative',
    apiDocs: '/docs/hrms-api',
    userDocs: '/docs/hrms-user'
  },
  {
    id: 'asset-management',
    name: 'Asset Management',
    description: 'Municipal asset tracking, maintenance, and lifecycle management',
    icon: 'ri-building-2-line',
    category: 'Administrative',
    apiDocs: '/docs/asset-api',
    userDocs: '/docs/asset-user'
  },
  {
    id: 'document-management',
    name: 'Document Management',
    description: 'Digital document storage, version control, and access management',
    icon: 'ri-folder-line',
    category: 'Administrative',
    apiDocs: '/docs/document-api',
    userDocs: '/docs/document-user'
  },
  {
    id: 'ulb-dashboards',
    name: 'ULB Dashboards',
    description: 'Real-time analytics and performance monitoring dashboards',
    icon: 'ri-dashboard-line',
    category: 'Administrative',
    apiDocs: '/docs/dashboard-api',
    userDocs: '/docs/dashboard-user'
  },
  {
    id: 'workflow-management',
    name: 'Workflow & Role Management',
    description: 'Business process automation and role-based access control',
    icon: 'ri-flow-chart',
    category: 'Administrative',
    apiDocs: '/docs/workflow-api',
    userDocs: '/docs/workflow-user'
  },
  {
    id: 'common-masters',
    name: 'Common Masters',
    description: 'Centralized master data management for consistent data across modules',
    icon: 'ri-database-2-line',
    category: 'Administrative',
    apiDocs: '/docs/masters-api',
    userDocs: '/docs/masters-user'
  }
];

export const frameworkComponents = [
  {
    id: 'core-engine',
    name: 'Core Engine',
    description: 'Central processing engine with business logic and rule management',
    icon: 'ri-cpu-line',
    category: 'Framework Components',
    apiDocs: '/docs/core-engine-api',
    userDocs: '/docs/core-engine-user'
  },
  {
    id: 'microservices',
    name: 'Microservices',
    description: 'Distributed service architecture for scalable and maintainable applications',
    icon: 'ri-service-line',
    category: 'Framework Components',
    apiDocs: '/docs/microservices-api',
    userDocs: '/docs/microservices-user'
  },
  {
    id: 'api-gateway',
    name: 'API Gateway',
    description: 'Centralized API management, routing, and security enforcement',
    icon: 'ri-router-line',
    category: 'Framework Components',
    apiDocs: '/docs/api-gateway-api',
    userDocs: '/docs/api-gateway-user'
  },
  {
    id: 'authentication',
    name: 'Authentication',
    description: 'Secure user authentication and authorization management system',
    icon: 'ri-shield-user-line',
    category: 'Framework Components',
    apiDocs: '/docs/auth-api',
    userDocs: '/docs/auth-user'
  },
  {
    id: 'notification-service',
    name: 'Notification Service',
    description: 'Multi-channel notification delivery via SMS, email, and push notifications',
    icon: 'ri-notification-line',
    category: 'Framework Components',
    apiDocs: '/docs/notification-api',
    userDocs: '/docs/notification-user'
  },
  {
    id: 'localization',
    name: 'Localization',
    description: 'Multi-language support and regional customization capabilities',
    icon: 'ri-translate-line',
    category: 'Framework Components',
    apiDocs: '/docs/localization-api',
    userDocs: '/docs/localization-user'
  },
  {
    id: 'data-exchange',
    name: 'Data Exchange APIs',
    description: 'Standardized APIs for inter-system data exchange and integration',
    icon: 'ri-exchange-line',
    category: 'Integrations',
    apiDocs: '/docs/data-exchange-api',
    userDocs: '/docs/data-exchange-user'
  },
  {
    id: 'analytics-mis',
    name: 'Analytics and MIS Reports',
    description: 'Advanced analytics engine with customizable reporting and insights',
    icon: 'ri-bar-chart-line',
    category: 'Integrations',
    apiDocs: '/docs/analytics-api',
    userDocs: '/docs/analytics-user'
  }
];

export const allModules = [...coreModules, ...administrativeModules, ...frameworkComponents];

export const moduleCategories = [
  'All',
  'Citizen Services',
  'Administrative',
  'Framework Components',
  'Integrations'
];

